import React from "react";
import "./Receiver_info_holder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
// import Cancel_Order_btn from "../../../common-components/common_btn/cancel_Order_btn/Cancel_Order_btn";
import { useNavigate } from "react-router-dom";
import Cancel_Order_btn from "../../../common_components/common_btn/cancel_Order_btn/Cancel_Order_btn";
import { encodeId } from "../../../../utils/common";
import Red_Outline_Btn from "../../../common_components/common_btn/red_outline_btn/Red_Outline_Btn";

function Receiver_info_holder({
  id,
  user,
  order,
  userAddress,
  billing_user_address,
  showCancelBtn,
}) {
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/cancel-order/${id}`);
  };
  const handleClickReturn = (id) => {
    navigate(`/return-order/${id}`);
  };
  const parts = [
    userAddress?.building,
    userAddress?.street,
    userAddress?.apartment,
    userAddress?.Users_Address_Detail?.Country?.name,
    userAddress?.Users_Address_Detail?.State?.name,
    userAddress?.Users_Address_Detail?.City?.name,
    userAddress?.Users_Address_Detail?.Pincode?.name,
  ];
  const billingparts = [
    billing_user_address?.building,
    billing_user_address?.street,
    billing_user_address?.apartment,
    billing_user_address?.Users_Address_Detail?.Country?.name,
    billing_user_address?.Users_Address_Detail?.State?.name,
    billing_user_address?.Users_Address_Detail?.City?.name,
    billing_user_address?.Users_Address_Detail?.Pincode?.name,
  ];

  return (
    <>
      <section className="Receiver_info_holder">
        <div className="text_holder">
          <h4>{user?.name + " " + user?.last_name}</h4>
          <div className="name_holder">
            <div>
              <div className="icon_holder">
                <FontAwesomeIcon className="info_icon" icon={faPhone} />
              </div>
            </div>
            <p>+ {user?.contact_no}</p>
          </div>

          <p>Shipping Address</p>
          <div className="name_holder">
            <div>
              <div className="icon_holder">
                <FontAwesomeIcon className="info_icon" icon={faLocationDot} />
              </div>
            </div>
            <p> {parts?.filter(Boolean).join(", ")}</p>
          </div>

          <p>Billing Address</p>
          <div className="name_holder">
            <div>
              <div className="icon_holder">
                <FontAwesomeIcon className="info_icon" icon={faLocationDot} />
              </div>
            </div>
            <p> {billingparts?.filter(Boolean).join(", ")}</p>
          </div>
          {showCancelBtn && (
            <>
              {(order?.order_status_id === 2 ||
                order?.order_status_id === 1) && (
                <Cancel_Order_btn
                  order={order}
                  btnText={"Cancel Order"}
                  onClick={() => handleClick(order?.id)}
                />
              )}
              {Number(order?.order_status_id) === 5 && (
                <Cancel_Order_btn
                  order={order}
                  btnText={"Return Order"}
                  onClick={() => handleClickReturn(order?.id)}
                />
              )}
            </>
          )}
          {Number(order?.order_status_id) === 4 && (
            <div className="mt-4">
              <Red_Outline_Btn btn_name={order?.Order_Otp?.name} />
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default Receiver_info_holder;
